import { Route, Routes } from "react-router-dom";
import BudgetModule from ".";
import EngagementsRegister from "./EngagementsRegister";
import ExpensesReport from "./ExpensesReport";

const BudgetRoute = () => {
  return (
    <Routes>
      <Route path="/engagements" element={<EngagementsRegister />} />
      <Route path="/report" element={<ExpensesReport />} />
      <Route path="/:view" element={<BudgetModule />} />
      <Route path="/*" element={<BudgetModule />} />
    </Routes>
  );
};

export default BudgetRoute;
